/**
 * Outbrain Adapter
 * 
 * Adapts event data into Outbrain Pixel format.
 * 
 * Documentation:
 * - https://www.outbrain.com/help/advertisers/dynamic-values/
 * 
 * @since 1.51.0
 */

(function (pmw, $, undefined) {

	class OutbrainAdapter {
		
		/**
		 * Adapt event data to Outbrain Pixel format
		 * 
		 * @param {object} eventData - Event-specific data (product, order, etc.)
		 * @param {string} eventName - Standardized event name
		 * @param {object} context - Event context (user, page, etc.)
		 * @returns {object|null} Adapted data for Outbrain or null if pixel not loaded
		 */
		adapt(eventData, eventName, context) {
			
			// Check if Outbrain pixel is loaded
			if (!pmwDataLayer?.pixels?.outbrain?.loaded) {
				return null;
			}
			
			const eventMap = {
				'search': () => this.adaptSearch(eventData),
				'view_item': () => this.adaptViewContent(eventData),
				'add_to_cart': () => this.adaptAddToCart(eventData),
				'begin_checkout': () => this.adaptStartCheckout(eventData),
				'purchase': () => this.adaptPurchase(eventData),
			};
			
			if (!eventMap[eventName]) {
				return null;
			}
			
			return eventMap[eventName]();
		}
		
		/**
		 * Adapt search event
		 */
		adaptSearch(eventData) {
			return {
				event_name: pmwDataLayer.pixels.outbrain.event_names.search,
				event_data: null
			};
		}
		
		/**
		 * Adapt view_content event
		 */
		adaptViewContent(eventData) {
			return {
				event_name: pmwDataLayer.pixels.outbrain.event_names.view_content,
				event_data: null
			};
		}
		
		/**
		 * Adapt add_to_cart event
		 */
		adaptAddToCart(eventData) {
			return {
				event_name: pmwDataLayer.pixels.outbrain.event_names.add_to_cart,
				event_data: null
			};
		}
		
		/**
		 * Adapt start_checkout event
		 */
		adaptStartCheckout(eventData) {
			return {
				event_name: pmwDataLayer.pixels.outbrain.event_names.start_checkout,
				event_data: null
			};
		}
		
		/**
		 * Adapt purchase event
		 * https://www.outbrain.com/help/advertisers/dynamic-values/
		 */
		adaptPurchase(eventData) {
			return {
				event_name: pmwDataLayer.pixels.outbrain.event_names.purchase,
				event_data: {
					orderValue: String(pmwDataLayer.order.value.marketing),
					currency: pmwDataLayer.order.currency,
					orderId: String(pmwDataLayer.order.id),
				}
			};
		}
	}
	
	// Register the adapter
	pmw.registerAdapter('outbrain', new OutbrainAdapter(), {
		supportsS2S: false,
		supportsEventDeduplication: false,
		isActive: () => pmwDataLayer?.pixels?.outbrain?.advertiser_id ? true : false
	});
	
}(window.pmw = window.pmw || {}, jQuery));
